import api from '../api/axios';
import { getAccessToken } from '../stores/auth/services';
import encryptedStorage from '../stores/encryptedStorage';
import store from '../stores/store';

export const localLogoutUser = async (accountWasDeleted = false) => {
  // store lastLoginEmail in memory, to transfer it to the new encrypted storage initialized with a new encryption key
  const { lastLoginEmail, isTherapistDemo } = store.getState();
  await encryptedStorage().destroyEncryptionKey();
  if (store.getState().isAuthenticated) {
    if (store.getState().therapistWebAppLogin) {
      store.getActions().setTherapistWebAppLogin(false);
      window.location.href = window.location.href.split('?')[0];
    }

    await store.getActions().setIsAuthenticated(false);
    await store.getActions().reset();
    await store.persist.clear();
    await encryptedStorage().clear();

    if (accountWasDeleted) {
      await encryptedStorage().setItem('accountWasDeleted', 'true');
    }

    if (!isTherapistDemo) {
      await store.getActions().setLastLoginEmail(lastLoginEmail);
    }
  }
};

export const serverLogoutUser = (payload: { jwt: string }) => {
  if (payload.jwt && payload.jwt.length > 2) {
    return api.post('/api/auth/signout/v2', payload);
  } else {
    return null;
  }
};

export function useAuth() {
  async function logout() {
    try {
      await serverLogoutUser({ jwt: (await getAccessToken()) ?? '' });
      await localLogoutUser();
    } catch {
      await localLogoutUser();
    }
  }

  return { logout };
}
